import React from "react";
import { Sidebar, Menu, MenuItem, menuClasses } from "react-pro-sidebar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LoginIcon from "@mui/icons-material/Login";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { logout } from "../../redux/slices/userSlice";
import logo from "../../Images/BizBridge-Logo-1.png";

const SidebarAdm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const { confirm } = Modal;
  const handleLogout = () => {
    confirm({
      title: "Are you sure you want to Log out?",
      icon: <ExclamationCircleOutlined />,
      content: "Your current session will be terminated.",
      onOk() {
        dispatch(logout());
        localStorage.clear();
        message.success("Logout Successfully");
         window.location.reload("/login");
      },
    });
  };

  return (
    <>
      <Sidebar backgroundColor="white" style={{ borderRightStyle: "none" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box>
            <Menu
              menuItemStyles={{
                button: {
                  [`&.${menuClasses.button}`]: {
                    color: "#000",
                  },
                  [`&.${menuClasses.disabled}`]: {
                    color: "green",
                  },
                  "&:hover": {
                    backgroundColor: "#fafafa",
                    color: "#1976d2",
                  },
                },

                icon: {
                  [`&.${menuClasses.icon}`]: {
                    color: "#1976d2",
                  },
                },
              }}
            >
              <Box
                component={Link}
                to="/admin-dashboard"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  padding: "2px 16px",
                }}
              >
                <img
                  src={logo}
                  alt="BizBridge Logo"
                  style={{
                    height: "45px",
                    width: "45px",
                    marginRight: "10px",
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "28px",
                    color: "#0c2742",
                    marginTop: "20px",
                  }}
                >
                  BizBridge
                </Typography>
              </Box>

              <hr />
              <MenuItem
                component={<Link to="/admin-dashboard" />}
                icon={<DashboardIcon />}
              >
                {" "}
                Dashboard{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/users" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Users{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/seller-categories" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Product Categories{" "}
              </MenuItem>

              <MenuItem
                component={<Link to="/admin/seller-product" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Products{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/buyer-categories" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Buyer Categories{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/contact" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Contact{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/profile" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Manage Accounts{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/orders" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Orders{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/pending-invoices" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Pending Invoices{" "}
              </MenuItem>
              <MenuItem
                component={<Link to="/admin/support" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Support{" "}
              </MenuItem>

              <MenuItem
                component={<Link to="/admin/plan" />}
                icon={<ManageAccountsIcon />}
              >
                {" "}
                Plans{" "}
              </MenuItem>
            </Menu>
          </Box>

          {/* Log Out  */}
          <Box sx={{ pb: 2 }}>
            <Menu
              menuItemStyles={{
                button: {
                  [`&.${menuClasses.button}`]: {
                    color: "#000",
                  },

                  "&:hover": {
                    backgroundColor: "#fafafa",
                    color: "#1976d2",
                  },
                },

                icon: {
                  [`&.${menuClasses.icon}`]: {
                    color: "#1976d2",
                  },
                },
              }}
            >
              <hr />
              <MenuItem onClick={handleLogout} icon={<LoginIcon />}>
                {" "}
                Log out{" "}
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Sidebar>
    </>
  );
};

export default SidebarAdm;
